import { FC } from "react";
import { Box, Grid, Heading, Spinner } from "@radix-ui/themes";
import { useTenantZones } from "@/features/zones/hooks/useZones";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import SingleZoneCard from "./SingleZoneCard";
import CoverCarousel from "@/components/CoverCarousel/CoverCarousel";
import { dummyCarouselData } from "../../constants/dummy.overview.carousel";

const ZonesOverview: FC = (): JSX.Element => {
  const { data, loading, error } = useTenantZones(brand.tenantId);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <FormErrorMessage text={error.message} isVisible={true} />;
  }

  return (
    <Box>
      <CoverCarousel slides={dummyCarouselData} interval={12000} />
      <Heading as="h2" size="5" mb="3">
        Discover our zones
      </Heading>
      <Grid columns={{ initial: "2", lg: "5" }}>
        {data &&
          data.map((zone) => <SingleZoneCard key={zone.slug} {...zone} />)}
      </Grid>
    </Box>
  );
};

export default ZonesOverview;
